
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loader2, Shield } from "lucide-react";
import { FormTextarea } from "@/components/ui/form-textarea";

interface QuestionFormProps {
  question: string;
  setQuestion: (question: string) => void;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
  isLoading: boolean;
}

const QuestionForm: React.FC<QuestionFormProps> = ({
  question,
  setQuestion,
  handleSubmit,
  isLoading
}) => {
  return (
    <Card className="mb-8 border-heaven-gold/20 shadow-md">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-xl font-semibold text-[#403E43]">
          <Shield className="h-5 w-5" />
          Ask a tough question
        </CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <FormTextarea
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            placeholder="Ask a tough question about atheism, secularism, or moral relativism..."
            className="h-32"
          />
          <Button
            type="submit"
            className="w-full bg-heaven-gold hover:bg-heaven-dark-gold text-white py-6"
            disabled={isLoading || !question.trim()}
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Processing...
              </>
            ) : (
              "Get Biblical Response"
            )}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};

export default QuestionForm;
